var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 17,
    fill: "#F2F2F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1875 9.125L21 10.5L19.2812 9.125C19.2188 9.0625 19.0625 9 19 9C18.9062 9 18.75 9.0625 18.6875 9.125L17 10.5L15.2812 9.125C15.2188 9.0625 15.0625 9 15 9C14.9062 9 14.75 9.0625 14.6875 9.125L13 10.5L11.7812 9.125C11.4688 8.875 11 9.09375 11 9.5V24.5C11 24.9375 11.4688 25.1562 11.7812 24.9062L13 23.5L14.6875 24.9062C14.75 24.9688 14.9062 25.0312 15 25.0312C15.0625 25.0312 15.2188 24.9688 15.2812 24.9062L17 23.5L18.6875 24.9062C18.75 24.9688 18.9062 25.0312 19 25.0312C19.0625 25.0312 19.2188 24.9688 19.2812 24.9062L21 23.5L22.1875 24.9062C22.5 25.1562 23 24.9375 23 24.5V9.5C23 9.09375 22.5312 8.875 22.1875 9.125ZM21 20.25C21 20.4062 20.875 20.5 20.75 20.5H13.25C13.0938 20.5 13 20.4062 13 20.25V19.75C13 19.625 13.0938 19.5 13.25 19.5H20.75C20.875 19.5 21 19.625 21 19.75V20.25ZM21 17.25C21 17.4062 20.875 17.5 20.75 17.5H13.25C13.0938 17.5 13 17.4062 13 17.25V16.75C13 16.625 13.0938 16.5 13.25 16.5H20.75C20.875 16.5 21 16.625 21 16.75V17.25ZM21 14.25C21 14.4062 20.875 14.5 20.75 14.5H13.25C13.0938 14.5 13 14.4062 13 14.25V13.75C13 13.625 13.0938 13.5 13.25 13.5H20.75C20.875 13.5 21 13.625 21 13.75V14.25Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBill);
export default __webpack_public_path__ + "static/media/bill.9de18956.svg";
export { ForwardRef as ReactComponent };